import styled from "styled-components";

export const Container = styled.div`
  grid-column: 1 / -1;
  &:not(:last-child) {
    margin-bottom: 2.5rem;
  }
`;

export const Label = styled.span<{ $hide?: boolean; }>`
  display: ${({ $hide }) => ($hide) ? "none": "block" };
  margin-bottom: 1em;
  font-weight: 700;
  font-size: 0.875rem;
  font-family: "Arial";
`;

export const Content = styled.div<{ $hide?: boolean; }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  margin-top: ${({ $hide }) => ($hide) ? "0": "1rem" };
`;
